import { render } from "./DescriptionView.vue?vue&type=template&id=f393e51c&scoped=true"
import script from "./DescriptionView.vue?vue&type=script&lang=js"
export * from "./DescriptionView.vue?vue&type=script&lang=js"

import "./DescriptionView.vue?vue&type=style&index=0&id=f393e51c&lang=scss&scoped=true"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f393e51c"]])

export default __exports__